module.exports = __webpack_public_path__ + "static/media/konqiyuan2.547a4a5f.jpg";